import { useEffect, useState } from "react";

/** Launcher element the TanStack Query devtools mount in the viewport corner. */
const DEVTOOLS_BUTTON_SELECTOR = ".tsqd-open-btn-container";

/* The devtools are stripped from production bundles, and a DOM is not guaranteed under SSR or in
   test runners, so neither case pays for a document-wide subtree watch that can never match. */
const canDevtoolsMount = (): boolean => process.env.NODE_ENV !== "production" && typeof document !== "undefined";

const hasDevtoolsButton = (): boolean => {
  if (!canDevtoolsMount()) return false;

  return document.querySelector(DEVTOOLS_BUTTON_SELECTOR) !== null;
};

/**
 * Reports whether the TanStack Query devtools launcher is currently on the page. The devtools are
 * mounted per module rather than once by the shell, so a build-mode check alone would over-report on
 * the routes that never render them.
 */
export const useHasQueryDevtoolsButton = (): boolean => {
  const [isPresent, setIsPresent] = useState(hasDevtoolsButton);

  useEffect(() => {
    if (!canDevtoolsMount()) return;

    const observer = new MutationObserver(() => setIsPresent(hasDevtoolsButton()));
    observer.observe(document.body, { childList: true, subtree: true });

    setIsPresent(hasDevtoolsButton());

    return () => observer.disconnect();
  }, []);

  return isPresent;
};
